module.exports = __webpack_public_path__ + "img/qx_icon5.4c968eb5.png";